module.exports = __webpack_public_path__ + "static/media/1-8.92e99ae9.png";